/* SC · Ficha de producto: líneas que dependen de Easify, entrega, Klarna, stock real y barra fija de compra.
   La barra nunca añade por su cuenta: pulsa el botón real (#teeAtcButton en Teeinblue, el de Ella en el resto),
   que es el que valida la personalización. */
(function () {
  'use strict';

  var TEE_BTN = '#teeAtcButton';
  var ELLA_BTN = '.halo-productView-right #product-add-to-cart';

  function isTee() { return !!document.querySelector(TEE_BTN) || document.body.classList.contains('teeinblue-enabled'); }
  function isEasify() { return !!document.querySelector('.easify-product-options .tpo_has-option-set'); }
  function realBtn() { return document.querySelector(TEE_BTN) || document.querySelector(ELLA_BTN); }
  function visible(el) { return !!(el && el.offsetParent !== null); }

  /* Listas con líneas condicionadas (ventajas genéricas y garantías): se decide al saber si hay Easify. */
  function applyPerks() {
    var lists = document.querySelectorAll('.sc-perks:not(.sc-perks--producto), .sc-tiles');
    var pend = [].filter.call(lists, function (l) { var m = l.getAttribute('data-sc-modo'); return m !== 'tee' && m !== 'easify' && m !== 'sin'; });
    if (!pend.length) return true;
    var known = !!document.querySelector('.easify-product-options .tpo_option-set-wrapper');
    if (!known) return false;
    var ez = isEasify();
    pend.forEach(function (list) {
      list.querySelectorAll('[data-sc-cond]').forEach(function (li) {
        var c = li.getAttribute('data-sc-cond');
        if (c === 'pers' || c === 'easify') li.hidden = !ez;
        if (c === 'sin') li.hidden = ez;
      });
      list.setAttribute('data-sc-modo', ez ? 'easify' : 'sin');
    });
    return true;
  }

  function priceText() {
    var cands = ['[data-sc-tee-now]', '.tee-price--current', '.productView-price .price__sale .price-item--sale', '.productView-price .price-item--regular'];
    for (var i = 0; i < cands.length; i++) {
      var els = document.querySelectorAll('.halo-productView-right ' + cands[i]);
      for (var j = 0; j < els.length; j++) {
        if (visible(els[j]) && /\d/.test(els[j].textContent)) return els[j].textContent.trim();
      }
    }
    return null;
  }

  function personalizable() { return isTee() || isEasify(); }

  /* Primer elemento VISIBLE de la lista de selectores. En Easify sin variantes, .productView-options existe
     pero está oculto (su posición es 0) y la barra no movía la página: hay que saltárselo. */
  function firstVisible(sels) {
    for (var i = 0; i < sels.length; i++) {
      var els = document.querySelectorAll(sels[i]);
      for (var j = 0; j < els.length; j++) if (visible(els[j]) && els[j].offsetHeight > 0) return els[j];
    }
    return null;
  }

  function formTop() {
    var f = firstVisible(['.halo-productView-right .productView-options', '.easify-product-options .tpo_has-option-set', '.easify-product-options']);
    var rb = realBtn();
    if (!f && visible(rb)) f = rb;
    return f ? f.getBoundingClientRect().top + window.pageYOffset : null;
  }

  function headerOffset() {
    var h = document.querySelector('.section-header-navigation.is-sticky, .header-sticky, .shopify-section-header-sticky');
    return (h ? h.offsetHeight : 0) + 16;
  }

  function cartOpened() {
    var b = document.body.classList;
    return b.contains('wow-cart-opened') || b.contains('cart-sidebar-show') || /\/cart/.test(location.pathname);
  }

  /* ---------- Precio, Klarna y stock ---------- */
  function cents(txt) {
    if (!txt) return null;
    var t = txt.replace(/[^\d,.]/g, '');
    if (t.indexOf(',') > -1) t = t.replace(/\./g, '').replace(',', '.');
    var n = parseFloat(t);
    return isNaN(n) ? null : Math.round(n * 100);
  }
  function money(c) { return (c / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'; }
  function currentCents() { return cents(priceText()); }

  function updateKlarna() {
    var el = document.querySelector('[data-sc-klarna-cuota]');
    var c = currentCents();
    if (el && c) el.textContent = money(Math.ceil(c / 3));
  }

  function variantId() {
    var i = document.querySelector('.halo-productView-right form[action*="/cart/add"] [name="id"]');
    return i ? String(i.value) : null;
  }
  function updateStock() {
    var el = document.querySelector('[data-sc-stock]');
    if (!el) return;
    var map = {};
    try { map = JSON.parse(el.getAttribute('data-map')); } catch (e) {}
    var q = map[variantId()] || 0;
    el.hidden = !q;
    if (q) el.querySelector('[data-sc-stock-text]').textContent = q === 1 ? el.getAttribute('data-text-1') : el.getAttribute('data-text').replace('[n]', q);
  }

  /* ---------- Entrega: fechas, cuenta atrás y envío gratis (hora de Madrid) ---------- */
  function madridNow() {
    var parts = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false })
      .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return { y: +parts.year, m: +parts.month, d: +parts.day, h: +parts.hour % 24, min: +parts.minute };
  }
  function ymd(dt) { return dt.toISOString().slice(0, 10); }
  function fmtDay(dt) {
    return new Intl.DateTimeFormat('es-ES', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' }).format(dt).replace(/[,.]/g, '');
  }
  function fmtLong(dt) {
    return new Intl.DateTimeFormat('es-ES', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' }).format(dt).replace(',', '');
  }

  function initEntrega() {
    var box = document.querySelector('[data-sc-ship]');
    if (!box) return;
    var corte = +box.getAttribute('data-corte'), dmin = +box.getAttribute('data-min'), dmax = Math.max(dmin, +box.getAttribute('data-max'));
    var festivos = (box.getAttribute('data-festivos') || '').split(',');
    function lab(dt) { var w = dt.getUTCDay(); return w !== 0 && w !== 6 && festivos.indexOf(ymd(dt)) === -1; }
    function addLab(dt, n) { var x = new Date(dt); while (n > 0) { x.setUTCDate(x.getUTCDate() + 1); if (lab(x)) n--; } return x; }
    function nextLab(dt) { var x = new Date(dt); do { x.setUTCDate(x.getUTCDate() + 1); } while (!lab(x)); return x; }

    var fechas = box.querySelector('[data-sc-ship-fechas]'), corteEl = box.querySelector('[data-sc-ship-corte]'), free = box.querySelector('[data-sc-ship-free]');

    function tick() {
      var n = madridNow();
      var hoy = new Date(Date.UTC(n.y, n.m - 1, n.d));
      var mins = n.h * 60 + n.min;
      var entraHoy = lab(hoy) && mins < corte * 60;
      var inicio = entraHoy ? hoy : nextLab(hoy);
      var desde = addLab(inicio, dmin), hasta = addLab(inicio, dmax);
      var tf = fechas.getAttribute('data-tpl');
      fechas.querySelector('[data-sc-out]').innerHTML = tf.replace('[desde]', '<strong>' + fmtDay(desde) + '</strong>').replace('[hasta]', '<strong>' + fmtDay(hasta) + '</strong>');
      fechas.hidden = false;
      var out = corteEl.querySelector('[data-sc-out]');
      if (entraHoy) {
        var falta = corte * 60 - mins;
        var h = Math.floor(falta / 60), mi = falta % 60;
        var t = h && mi ? h + 'h ' + mi + 'min' : (h ? h + 'h' : mi + 'min');
        out.innerHTML = corteEl.getAttribute('data-tpl').replace('[tiempo]', '<strong>' + t + '</strong>').replace(' hoy ', ' <strong>hoy</strong> ');
      } else if (!corteEl.getAttribute('data-tpl-luego')) {
        corteEl.hidden = true;
        return;
      } else {
        var manana = new Date(hoy); manana.setUTCDate(manana.getUTCDate() + 1);
        var dia = ymd(inicio) === ymd(manana) ? 'mañana' : 'el ' + fmtLong(inicio);
        out.innerHTML = corteEl.getAttribute('data-tpl-luego').replace('el [dia]', '[dia]').replace('[dia]', '<strong>' + dia + '</strong>');
      }
      corteEl.classList.toggle('is-today', entraHoy);
      corteEl.hidden = false;
    }

    var cartTotal = null, cartItems = [];
    // Cantidad elegida en la ficha (1 si el formulario no tiene campo de cantidad, como en Teeinblue y Easify).
    function qtyFicha() {
      var q = document.querySelector('.halo-productView-right form[action*="/cart/add"] [name="quantity"]') || document.querySelector('.halo-productView-right [name="quantity"]');
      var n = q ? parseInt(q.value, 10) : 1;
      return n > 0 ? n : 1;
    }
    function renderFree() {
      if (!free || cartTotal === null) return;
      var umbral = +box.getAttribute('data-umbral');
      var precio = currentCents() || +box.getAttribute('data-precio');
      // Si la variante que se está viendo ya está en el carrito, su precio ya va en el total: no se suma otra vez.
      var vid = variantId();
      var enCarrito = !!vid && cartItems.some(function (it) { return String(it.variant_id) === vid; });
      var total = enCarrito ? cartTotal : cartTotal + precio * qtyFicha();
      var falta = umbral - total;
      free.querySelector('[data-sc-out]').innerHTML = falta > 0
        ? free.getAttribute('data-tpl').replace('[falta]', '<strong>' + money(falta) + '</strong>')
        : free.getAttribute('data-tpl-ok');
      // Hacia abajo y sin llegar al 100 % mientras falte algo (con 49,95 € la barra no puede salir llena).
      free.querySelector('i').style.width = (falta > 0 ? Math.min(99, Math.floor(total * 100 / umbral)) : 100) + '%';
      free.classList.toggle('is-ok', falta <= 0);
      free.hidden = false;
    }
    function loadCart() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
        .then(function (c) { cartTotal = c.total_price || 0; cartItems = c.items || []; renderFree(); }).catch(function () {});
    }

    tick();
    loadCart();
    setInterval(tick, 30000);
    // Al cambiar opciones cambia el precio; al añadir o quitar del carrito cambia el total.
    document.addEventListener('change', function () { setTimeout(renderFree, 400); }, true);
    document.addEventListener('click', function () { setTimeout(renderFree, 500); setTimeout(loadCart, 2500); });
  }

  function initSticky() {
    var bar = document.querySelector('[data-sc-sticky]');
    if (!bar) return;
    var btn = bar.querySelector('[data-sc-sticky-btn]');
    var priceEl = bar.querySelector('[data-sc-sticky-price]');
    var footer = document.querySelector('footer, .footer, #shopify-section-footer');
    var state = { below: true };
    bar.hidden = false;

    function setH() { document.documentElement.style.setProperty('--sc-sticky-h', bar.offsetHeight + 'px'); }

    // Se mide en cada scroll (no con IntersectionObserver): un salto de scroll por encima del botón no cambia
    // su intersección y el observador no avisaría.
    function render() {
      var rb = realBtn();
      var vh = window.innerHeight;
      var show = false;
      if (rb && visible(rb) && !(rb.disabled || rb.classList.contains('is-soldout'))) {
        var r = rb.getBoundingClientRect();
        var inView = r.bottom > 0 && r.top < vh;
        state.below = r.top >= vh;
        var f = footer && footer.getBoundingClientRect();
        var footerInView = !!f && f.top < vh;
        show = !inView && !footerInView && !cartOpened();
      }
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('sc-sticky-on', show);
      var goForm = personalizable() && state.below;
      btn.textContent = goForm ? btn.getAttribute('data-label-pers') : btn.getAttribute('data-label-add');
      var p = priceText();
      if (p) priceEl.textContent = p;
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; render(); });
    }, { passive: true });

    btn.addEventListener('click', function () {
      var rb = realBtn();
      if (!rb) return;
      if (personalizable() && state.below) {
        var top = formTop();
        if (top === null) { rb.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        window.scrollTo({ top: Math.max(0, top - headerOffset()), behavior: 'smooth' });
        return;
      }
      rb.click();
      // Si falta algo por rellenar, el botón real no añade: se lleva al cliente a ver el aviso.
      setTimeout(function () {
        if (!cartOpened()) rb.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 1500);
    });

    // El botón de Teeinblue y el precio llegan tarde y cambian con las opciones.
    var tries = 0;
    var t = setInterval(function () {
      render();
      if (++tries > 40) clearInterval(t);
    }, 500);
    document.addEventListener('change', function () { setTimeout(render, 300); }, true);
    document.addEventListener('click', function () { setTimeout(render, 400); });
    window.addEventListener('resize', setH);
    setH();
  }

  /* Upsell: añadir con un clic (solo productos sin personalizar ni opciones) y abrir el carrito. */
  function initUpsell() {
    document.querySelectorAll('[data-sc-up-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        var txt = b.textContent;
        b.disabled = true; b.textContent = '…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.getAttribute('data-sc-up-add'), quantity: 1 }] }) })
          .then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function () {
            b.textContent = '✓';
            if (window.scAbrirCarrito) window.scAbrirCarrito(); else location.href = '/cart';
            setTimeout(function () { b.textContent = txt; b.disabled = false; }, 2500);
          })
          .catch(function () { b.textContent = txt; b.disabled = false; });
      });
    });
  }

  /* Precio de Teeinblue arriba: copia en directo el que Teeinblue pinta en su formulario (oculto). */
  function syncTeePrice() {
    var box = document.querySelector('[data-sc-tee-price]');
    var src = document.querySelector('.halo-productView-right .tee-price-wrapper');
    if (!box || !src) return;
    var now = src.querySelector('.tee-price--current');
    var old = [].filter.call(src.querySelectorAll('span, s, del'), function (e) { return e !== now && /compare|original|old/i.test(e.className) && /\d/.test(e.textContent); })[0];
    if (now && /\d/.test(now.textContent)) box.querySelector('[data-sc-tee-now]').textContent = now.textContent.trim();
    var o = box.querySelector('[data-sc-tee-old]');
    if (old) {
      if (!o) { o = document.createElement('s'); o.className = 'sc-tee-price__old'; o.setAttribute('data-sc-tee-old', ''); box.insertBefore(o, box.firstChild); box.insertBefore(document.createTextNode(' '), o.nextSibling); }
      o.textContent = old.textContent.trim();
    } else if (o) { o.remove(); }
  }
  function initTeePrice() {
    if (!document.querySelector('[data-sc-tee-price]')) return;
    var n = 0;
    var t = setInterval(function () {
      var src = document.querySelector('.halo-productView-right .tee-price-wrapper');
      if (src) {
        clearInterval(t);
        syncTeePrice();
        new MutationObserver(syncTeePrice).observe(src, { childList: true, subtree: true, characterData: true });
      } else if (++n > 60) clearInterval(t);
    }, 250);
  }

  /* Teeinblue abre con su primera opción aunque esté agotada: se marca la primera que tenga stock. */
  function initTeeStock() {
    var dat = document.getElementById('sc-stock-opciones');
    if (!dat) return;
    var stock = {};
    try {
      // Una opción con varias variantes cuenta con stock si alguna lo tiene.
      JSON.parse(dat.textContent).forEach(function (p) { stock[p[0]] = stock[p[0]] || p[1]; });
    } catch (e) { return; }
    var n = 0;
    var t = setInterval(function () {
      var f = document.querySelector('.halo-productView-right .tee-field--teeinblue-available-prod');
      if (!f && ++n < 60) return;
      clearInterval(t);
      if (!f) return;
      var labs = [].slice.call(f.querySelectorAll('label[data-title]'));
      var key = function (l) { return (l.getAttribute('data-title') || '').toLowerCase().trim(); };
      var marcada = labs.filter(function (l) { var i = document.getElementById(l.htmlFor); return i && i.checked; })[0];
      if (!marcada || stock[key(marcada)] !== false) return;
      var buena = labs.filter(function (l) { return stock[key(l)] === true; })[0];
      if (buena) buena.click();
    }, 250);
  }

  function init() {
    if (!applyPerks()) {
      var n = 0;
      var t = setInterval(function () { if (applyPerks() || ++n > 30) clearInterval(t); }, 300);
    }
    initSticky();
    initEntrega();
    initTeePrice();
    initTeeStock();
    initUpsell();
    var k = 0;
    var t2 = setInterval(function () { updateKlarna(); updateStock(); if (++k > 20) clearInterval(t2); }, 600);
    document.addEventListener('change', function () { setTimeout(function () { updateKlarna(); updateStock(); }, 350); }, true);
    document.addEventListener('click', function () { setTimeout(updateKlarna, 450); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
